module.exports = new __parcel__URL__("down-arrow.8b6aeb0f.svg").toString();